import { api } from "../api";

export interface Banner {
  id: string;
  /** Дефолт-локаль (русский). */
  title: string | null;
  subtitle: string | null;
  cta_label: string | null;
  /**
   * Английские переводы, опциональны. Если пусты — используем русские поля.
   * Выбор языка делается на клиенте в `pickBannerCopy` — сервер отдаёт всё,
   * i18n-логика живёт рядом с UI.
   */
  title_en: string | null;
  subtitle_en: string | null;
  cta_label_en: string | null;
  image_url: string;
  /**
   * Отдельная картинка для тёмной темы. Если null — используем
   * `image_url` в обеих темах. Заполняется админом в `/banners`.
   */
  image_url_dark: string | null;
  link_url: string | null;
  bg_color: string | null;
  is_active: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

/**
 * Возвращает локализованный текстовый контент баннера под текущий язык i18n.
 * Правило простое: если английский язык и есть непустое английское поле —
 * берём английский, иначе фоллбэкимся на русский. Так же и с `subtitle` /
 * `cta_label` — каждое поле фоллбэкится независимо, чтобы админ мог
 * перевести, например, только заголовок и оставить остальное на русском.
 */
export function pickBannerCopy(
  banner: Banner,
  language: string,
): { title: string | null; subtitle: string | null; ctaLabel: string | null } {
  const isEn = language.toLowerCase().startsWith("en");
  const pick = (en: string | null, ru: string | null) =>
    isEn && en && en.trim() ? en : ru;
  return {
    title: pick(banner.title_en, banner.title),
    subtitle: pick(banner.subtitle_en, banner.subtitle),
    ctaLabel: pick(banner.cta_label_en, banner.cta_label),
  };
}

/** Публичный API: список активных баннеров для карусели на главной. */
export async function listBanners(): Promise<Banner[]> {
  const { data } = await api.get<Banner[]>("/banners");
  return data;
}
